export interface NotificationI {
  emailAddress: string;
  phoneNumber: string;
  isEmailOptIn: boolean;
}
